<template>
  <p class="text-caption">
    ©RS34.Published by mebius. ©2020 POWE UNIT / APOLLOSOFT. Warhammer 40,000:
    Shootas, Blood & Teef © Copyright Games Workshop Limited 2022. Shootas,
    Blood & Teef, the Shootas, Blood & Teef logo, GW, Games Workshop, Space
    Marine, 40K, Warhammer, Warhammer 40,000, 40,000, the ‘Aquila’ Double-headed
    Eagle logo, and all associated logos, illustrations, images, names,
    creatures, races, vehicles, locations, weapons, characters, and the
    distinctive likeness thereof, are either ® or TM, and/or © Games Workshop
    Limited, variably registered around the world, and used under licence.
    Rogueside NV and its logos are trademarks or registered trademarks of
    Rogueside NV. All rights reserved to their respective owners. Published by
    ININ Games. © 2022 Mitchell Corporation. Published by ININ Games. ©
    SEGA/LAT/BLISS BRAIN/UNITED GAMES ENTERTAINMENT GMBH ORIGINAL GAME ©
    SEGA/LAT. Tanuki Creative Studio, TCS ©. 2020, all rights reserved. 2022
    published by ININ Games. © 2011-2021 Qute Corporation / ESCHATOS project.
    All rights reserved. ©Animu Game/COSEN Published by COSEN ©COSEN © 2022-2023
    KEMCO/RideonJapan,Inc./Rideon,Inc. ©SUCCESS ©スタジオ最前線 ©SilverStarJapan
    ©AKALI ©SilverStarJapan ©BEEP ©RS34, INC. ©2022 Neotro Inc. All Rights
    Reserved. Published by Phoenixx Inc. ©'84,'92,'94,'95,'97,'02,'15 BIGWEST
    ©'07 BIGWEST/MFP・M ©bushiroad All Rights Reserved. ©2020-2022 Petit Depotto
    ©room_909 Published by Mediascape Co.,Ltd. ©mebius. ©STARFISH-SD INC.
    Development and management by mebius. ©上海アリス幻樂団 ©2016-2023
    Mediascape Co.,Ltd. / ©Hachikumasoft. Published by mebius. ※「東方蒼神縁起
    V」「東方幻想魔録 W」は東方 Project の二次創作作品です。 東方 Project
    の著作権は上海アリス幻樂団にあります。 ©飯島多紀哉. ©Shannon.
    Developped&Published by mebius. ©Rocket-Engine Co., Ltd. StudioSiestA 2016
    2023 ©2023 OPERAHOUSE/FAMILY SOFT
  </p>
</template>
